import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  width: 350px;
  height: 450px;
  border-radius: 8px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  background: #fff;
  padding: 16px;

  p {
    margin: 0 14px;
  }

  .inputArea {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px;
    input {
      width: 100%;
    }
  }

  button {
    width: 100%;
    margin: auto 0 0 0;
  }

  .login-btn {
    width: 90% !important;
    margin: 8px 16px;
  }

  @media (max-width: 800px) {
    width: 80%;
  }
`;
